// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c141815f","211":"99896e78","947":"5529d700"}[chunkId] + ".chunk.js";
};